// extracted by mini-css-extract-plugin
export default {"main":"Classfy_main__ZAa1g","content":"Classfy_content__qg4Me","accordion":"Classfy_accordion__6+x7N"};